import { Module } from "wrapper6";
import { toggleClass, hasClass, removeClass, addClass } from "../utils/_class-handlers";

var $ = jQuery;

export default class Scrollto extends Module {

	ready() {

        const NAV_ITEMS = document.querySelectorAll('.mtt-universe-nav li a, .course-nav li a');

        if (NAV_ITEMS.length) {

            for (let i = 0; i < NAV_ITEMS.length; i++) {

                const NAV_ITEM = NAV_ITEMS[i];

                NAV_ITEM.addEventListener('click', (e) => {

                    e.preventDefault();

                    const HASH = NAV_ITEM.getAttribute('href');

                    $('html, body').animate({
                        scrollTop: $(HASH).offset().top - 100
                    }, 1000);

                });
            }
        }

        /**
         * Scroll to review section on single course / education
         */
        const RATING_CONTAINER = document.querySelector('.single-course .rating-container, .single-education .rating-container');
        const REVIEW_SECTION = document.querySelector('.single-course .mtt-review-section, .single-education .mtt-review-section');

        if (RATING_CONTAINER && REVIEW_SECTION) {

            // Add clickable class
            addClass(RATING_CONTAINER, 'clickable');

            RATING_CONTAINER.addEventListener('click', () => {

                const ID = REVIEW_SECTION.getAttribute('id');

                if (ID !== '' && ID !== undefined) {
                    $('html, body').animate({
                        scrollTop: $('#'+ID).offset().top - 100
                    }, 1000);
                }
            });
        }
    }
}